import type { PayloadAction } from "@reduxjs/toolkit"

import { createEmbedChatInstance } from "../embedState"
import type { EmbedChatState } from "../embedTypes"

/**
 * Open embed chat (create if doesn't exist)
 */
export const openEmbedChat = (
  state: EmbedChatState,
  action: PayloadAction<{
    chatId: string
    integrationId: string
    sessionId: string
    isPreview?: boolean
  }>
) => {
  const { chatId, integrationId, sessionId, isPreview = false } = action.payload

  if (!state.chats[chatId]) {
    state.chats[chatId] = createEmbedChatInstance(chatId, integrationId, sessionId, isPreview)
  }

  state.chats[chatId].lastAccessedAt = Date.now()
  state.activeChatId = chatId
}

/**
 * Close embed chat
 */
export const closeEmbedChat = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string }>
) => {
  const { chatId } = action.payload
  delete state.chats[chatId]

  if (state.activeChatId === chatId) {
    state.activeChatId = null
  }
}

/**
 * Set active embed chat
 */
export const setActiveEmbedChat = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string | null }>
) => {
  state.activeChatId = action.payload.chatId
}

/**
 * Update embed chat topic (from WebSocket)
 */
export const updateEmbedChatTopic = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string; topic: string }>
) => {
  const { chatId, topic } = action.payload
  const chat = state.chats[chatId]

  if (chat) {
    chat.topic = topic
  }
}

/**
 * Stop sending message - immediate UI feedback when stop is requested
 * Clears streaming state and sets isSendingMessage to false
 */
export const stopEmbedSending = (
  state: EmbedChatState,
  action: PayloadAction<{ chatId: string }>
) => {
  const { chatId } = action.payload
  const chat = state.chats[chatId]

  if (chat) {
    chat.isSendingMessage = false
    chat.shouldShowDynamicWhitespace = false
    chat.streamingMessages = {}
  }
}
